import request from "./reque";
import request2 from "./reque2";
// import reque from './reque'
import qs from "qs";
export function formatMoney(s, type) {
  if (/[^0-9\.]/.test(s)) return "0";
  if (s == null || s == "") return "0";
  s = s.toString().replace(/^(\d*)$/, "$1.");
  s = (s + "00").replace(/(\d*\.\d\d)\d*/, "$1");
  s = s.replace(".", ",");
  var re = /(\d)(\d{3},)/;
  while (re.test(s)) s = s.replace(re, "$1,$2");
  s = s.replace(/,(\d\d)$/, ".$1");
  if (type == 0) {
    // 不带小数位(默认是有小数位)
    var a = s.split(".");
    if (a[1] == "00") {
      s = a[0];
    }
  }
  return s;
}
export function login(data) {
  return request({
    url: `/pms/pub/login`,
    method: "post",
    data
  });
}
export function modifyQuestion(data) {
  return request({
    url: `/pms/question/modifyQuestion`,
    method: "post",
    data
  });
}
export function selectQuestionByCondition(params) {
  return request({
    url: `/pms/question/selectQuestionByCondition`,
    method: "post",
    params
  });
}
export function selectUserRoleByRoleId(params) {
  return request({
    url: `/wts/admin/role/selectUserRoleByRoleId`,
    method: "get",
    params
  });
}

// -----------------------接口--------------------------------------
export function updateFinishDesc(params) {
  return request2({
    url: `/naire2/backFinish/updateFinishDesc`,
    method: "post",
    params
  });
}
export function saveFinishDesc(params) {
  return request2({
    url: `/naire2/backFinish/saveFinishDesc`,
    method: "post",
    params
  });
}
export function updateCustomRecommend(params) {
  return request2({
    url: `/naire2/backFinish/updateCustomRecommend`,
    method: "post",
    params
  });
}
export function saveCustomRecommend(params) {
  return request2({
    url: `/naire2/backFinish/saveCustomRecommend`,
    method: "post",
    params
  });
}
export function getFinishDesc(params) {
  return request2({
    url: `/naire2/backFinish/getFinishDesc`,
    method: "get",
    params
  });
}
export function getCustomRecommend(params) {
  return request2({
    url: `/naire2/backFinish/getCustomRecommend`,
    method: "get",
    params
  });
}

export function getAdvisoryOrder(params) {
  return request2({
    url: `/naire2/backAdvisoryOrder/getAdvisoryOrder`,
    method: "get",
    params
  });
}
export function getAnswerListOutline(params) {
  return request2({
    url: `/naire2/backAnswer/getAnswerListOutline`,
    method: "get",
    params
  });
}
export function deleteAdvise(params) {
  return request2({
    url: `/naire2/backAdvise/deleteAdvise`,
    method: "post",
    params
  });
}
export function updateAdvise(params) {
  return request2({
    url: `/naire2/backAdvise/updateAdvise`,
    method: "post",
    params
  });
}
export function backAdvise(params) {
  return request2({
    url: `/naire2/backAdvise/`,
    method: "post",
    params
  });
}
export function getbackAdvise(params) {
  return request2({
    url: `/naire2/backAdvise/`,
    method: "get",
    params
  });
}
export function getDepartItem(params) {
  return request2({
    url: `/naire2/departItem/getDepartItem`,
    method: "get",
    params
  });
}
export function getDepart(params) {
  return request2({
    url: `/naire2/departItem/getDepart`,
    method: "get",
    params
  });
}
export function updateAccord(params) {
  return request2({
    url: `/naire2/accord/updateAccord`,
    method: "post",
    params
  });
}
export function deleteAccord(params) {
  return request2({
    url: `/naire2/accord/deleteAccord`,
    method: "post",
    params
  });
}

export function accord(params) {
  return request2({
    url: `/naire2/accord/`,
    method: "get",
    params
  });
}
export function postaccord(params) {
  return request2({
    url: `/naire2/accord/`,
    method: "post",
    params
  });
}
export function updateOptions(params) {
  return request2({
    url: `/naire2/backOptions/updateOptions`,
    method: "post",
    params
  });
}
export function updateQuestion(params) {
  return request2({
    url: `/naire2/backQuestion/updateQuestion`,
    method: "post",
    data: params
  });
}
export function nairedeleteQuestion(data) {
  return request2({
    url: `/naire2/backQuestion/deleteQuestion`,
    method: "post",
    data
  });
}
export function deleteNaire(params) {
  return request2({
    url: `/naire2/backNaire/deleteNaire`,
    method: "post",
    params
  });
}
export function backOptions(params) {
  return request2({
    url: `/naire2/backOptions/`,
    method: "get",
    params
  });
}
export function backQuestion(params) {
  return request2({
    url: `/naire2/backQuestion/`,
    method: "get",
    params
  });
}
export function postbackQuestion(params) {
  return request2({
    url: `/naire2/backQuestion/`,
    method: "post",
    params
  });
}
export function questionGroup(params) {
  return request2({
    url: `/naire2/questionGroup/`,
    method: "get",
    params
  });
}
export function postquestionGroup(params) {
  return request2({
    url: `/naire2/questionGroup/`,
    method: "post",
    params
  });
}
export function updateQuestionGroup(params) {
  return request2({
    url: `/naire2/questionGroup/updateQuestionGroup`,
    method: "post",
    params
  });
}
export function backNaire(params) {
  return request2({
    url: `/naire2/backNaire/`,
    method: "get",
    params
  });
}
export function updateNaire(params) {
  return request2({
    url: `/naire2/backNaire/updateNaire`,
    method: "post",
    params
  });
}
export function postbackNaire(params) {
  return request2({
    url: `/naire2/backNaire/`,
    method: "post",
    params
  });
}
export function selectOrgReservationListForPage(params) {
  return request({
    url: `/pms/statistical/selectOrgReservationListForPage`,
    method: "get",
    params
  });
}
export function selectOrgReservationDetailsForPage(params) {
  return request({
    url: `/pms/statistical/selectOrgReservationDetailsForPage`,
    method: "get",
    params
  });
}
export function selectNoticeMessage(params) {
  return request({
    url: `/pms/booking/selectNoticeMessage`,
    method: "get",
    params
  });
}
export function setNoticeMessage(params) {
  return request({
    url: `/pms/booking/setNoticeMessage`,
    method: "post",
    params
  });
}
export function addOrUpdateBookingTimeFeeItem(params) {
  return request({
    url: `/pms/bookingTime/addOrUpdateBookingTimeFeeItem`,
    method: "post",
    params
  });
}
export function addOrUpdateBookingTime(params) {
  return request({
    url: `/pms/bookingTime/addOrUpdateBookingTime`,
    method: "post",
    params
  });
}
export function selectBookingTimeFeeItem(params) {
  return request({
    url: `/pms/bookingTime/selectBookingTimeFeeItem`,
    method: "get",
    params
  });
}
export function selectClassifyAll(params) {
  return request({
    url: `/pms/bookingTime/selectClassifyAll`,
    method: "get",
    params
  });
}
export function deleteBookingTime(params) {
  return request({
    url: `/pms/bookingTime/deleteBookingTime`,
    method: "get",
    params
  });
}
export function selectBookingTime(params) {
  return request({
    url: `/pms/bookingTime/selectBookingTime`,
    method: "get",
    params
  });
}
export function deleteBookingTimeFeeItem(params) {
  return request({
    url: `/pms/bookingTime/deleteBookingTimeFeeItem`,
    method: "get",
    params
  });
}
export function auditRefundApplyForHospital(params) {
  return request({
    url: `/pms/financial/auditRefundApplyForHospital`,
    method: "post",
    params
  });
}
export function financialselectOrderList(params) {
  return request({
    url: `/pms/financial/selectOrderList`,
    method: "get",
    params
  });
}
export function countFeeItem(params) {
  return request({
    url: `/pms/statistical/countFeeItem`,
    method: "post",
    params
  });
}
export function xianselectOrderDetails(params) {
  return request({
    url: `/pms/statistical/selectOrderDetails`,
    method: "post",
    params
  });
}
export function xianselectOrderList(params) {
  return request({
    url: `/pms/statistical/selectOrderList`,
    method: "post",
    params
  });
}

export function getinformation(params) {
  return request({
    url: `/pms/admin/information/getinformation`,
    method: "get",
    params
  });
}
export function logList(params) {
  return request({
    url: `/pms/admin/log/logList`,
    method: "get",
    params
  });
}
export function selectUploadSuccessPatientList(params) {
  return request({
    url: `/pms/booking/selectUploadSuccessPatientList`,
    method: "get",
    params
  });
}
export function addRolePermission(params) {
  return request({
    url: `/pms/admin/role/addRolePermission`,
    method: "post",
    params
  });
}
export function getRoleAllInfo(params) {
  return request({
    url: `/pms/admin/role/getRoleAllInfo`,
    method: "get",
    params
  });
}
export function getRoleListByUserId(params) {
  return request({
    url: `/pms/admin/perm/getRoleListByUserId`,
    method: "get",
    params
  });
}
export function deleteRole(params) {
  return request({
    url: `/pms/admin/role/deleteRole`,
    method: "post",
    params
  });
}

export function clearUserRole(params) {
  return request({
    url: `/pms/admin/perm/clearUserRole`,
    method: "post",
    params
  });
}
export function updateUserRole(params) {
  return request({
    url: `/pms/admin/perm/updateUserRole`,
    method: "post",
    params
  });
}
export function deleteRoleForUserList(params) {
  return request({
    url: `/pms/admin/perm/deleteRoleForUserList`,
    method: "post",
    params
  });
}
export function addRole(params) {
  return request({
    url: `/pms/admin/role/addRole`,
    method: "post",
    params
  });
}
export function selectRole(params) {
  return request({
    url: `/pms/admin/role/selectRole`,
    method: "get",
    params
  });
}
export function updateRole(params) {
  return request({
    url: `/pms/admin/role/updateRole`,
    method: "post",
    params
  });
}
export function addSeparatedEmployee(params) {
  return request({
    url: `/pms/admin/struc/addSeparatedEmployee`,
    method: "post",
    params
  });
}
export function addUser(params) {
  return request({
    url: `/pms/admin/struc/addUser`,
    method: "post",
    params
  });
}
export function updateStructure(params) {
  return request({
    url: `/pms/admin/struc/updateStructure`,
    method: "post",
    params
  });
}
export function getUserListByStructureId(params) {
  return request({
    url: `/pms/admin/struc/getUserListByStructureId`,
    method: "get",
    params
  });
}
export function addStructure(params) {
  return request({
    url: `/pms/admin/struc/addStructure`,
    method: "post",
    params
  });
}
export function exportUserList(params) {
  return request({
    url: `/pms/admin/struc/exportUserList`,
    method: "get",
    params
  });
}
export function getSeparatedEmployeeList(params) {
  return request({
    url: `/pms/admin/struc/getSeparatedEmployeeList`,
    method: "get",
    params
  });
}
export function searchStructionByName(params) {
  return request({
    url: `/pms/admin/struc/searchStructionByName`,
    method: "get",
    params
  });
}
export function getSubordinateList(params) {
  return request({
    url: `/pms/admin/struc/getSubordinateList`,
    method: "get",
    params
  });
}
export function addRoleToUserList(params) {
  return request({
    url: `/pms/admin/perm/addRoleToUserList`,
    method: "post",
    params
  });
}
export function deleteSeparatedEmployee(params) {
  return request({
    url: `/pms/admin/struc/deleteSeparatedEmployee`,
    method: "post",
    params
  });
}
export function updateUserInfoById(params) {
  return request({
    url: `/pms/admin/struc/updateUserInfoById`,
    method: "post",
    params
  });
}
export function deleteStructure(params) {
  return request({
    url: `/pms/admin/struc/deleteStructure`,
    method: "post",
    params
  });
}

export function getStructureTree(params) {
  return request({
    url: `/pms/admin/struc/getStructureTree`,
    method: "get",
    params
  });
}
export function refundItem(data) {
  return request({
    url: `/pms/refundItem/refundItem`,
    method: "post",
    data
  });
}
export function selectFeeItemOrderList(params) {
  return request({
    url: `/pms/refundItem/selectFeeItemOrderList`,
    method: "get",
    params
  });
}
export function selectOrderList(params) {
  return request({
    url: `/pms/refundItem/selectOrderList`,
    method: "get",
    params
  });
}
export function selectOrderList2(data) {
  return request({
    url: `/pms/financial/selectOrderList`,
    method: "post",
    data
  });
}

export function selectUpParent(data) {
  return request({
    url: `/pms/question/selectUpParent`,
    method: "post",
    data
  });
}
export function deleteQuestion(data) {
  return request({
    url: `/pms/question/deleteQuestion`,
    method: "post",
    data
  });
}
export function addQuestion(data) {
  return request({
    url: `/pms/question/addQuestion`,
    method: "post",
    data
  });
}
export function sendSmsCodeForNewAdmin(data) {
  return request({
    url: `/pms/admin/struc/sendSmsCodeForNewAdmin`,
    method: "post",
    data
  });
}
export function updateSystemAdmin(data) {
  return request({
    url: `/pms/admin/struc/updateSystemAdmin`,
    method: "post",
    data
  });
}
export function logout(params) {
  return request({
    url: `/pms/pub/logout`,
    method: "get",
    params
  });
}
export function selectUserById(params) {
  return request({
    url: `/pms/admin/struc/selectUserById`,
    method: "get",
    params
  });
}
export function getLoginUserPerms(params) {
  return request({
    url: `/pms/pub/getLoginUserPerms`,
    method: "get",
    params
  });
}
export function resetPassword(data) {
  return request({
    url: `/pms/pub/resetPassword`,
    method: "post",
    data
  });
}
export function getLoginUserInfoByToken(params) {
  return request({
    url: `/pms/pub/getLoginUserInfoByToken`,
    method: "get",
    params
  });
}
export function checkSmsPwdCode(data) {
  return request({
    url: `/pms/pub/checkSmsPwdCode`,
    method: "post",
    data
  });
}
export function sendSmsPwdCode(data) {
  return request({
    url: `/pms/pub/sendSmsPwdCode`,
    method: "post",
    data
  });
}
export function selectStatementRecordList(data) {
  return request({
    url: `/pms/financial/selectStatementRecordList`,
    method: "post",
    data
  });
}
export function generateStatement(data) {
  return request({
    url: `/pms/financial/generateStatement`,
    method: "post",
    data
  });
}
export function selectOrderListByStatementId(data) {
  return request({
    url: `/pms/financial/selectOrderListByStatementId`,
    method: "post",
    data
  });
}
export function commitStatement(data) {
  return request({
    url: `/pms/financial/commitStatement`,
    method: "post",
    data
  });
}
export function selectStatementList(data) {
  return request({
    url: `/pms/financial/selectStatementList`,
    method: "post",
    data
  });
}
export function selectOrgFeeItemInfoList(data) {
  return request({
    url: `/pms/statistical/selectOrgFeeItemInfoList`,
    method: "post",
    data
  });
}
export function selectOrgFeeItemList(data) {
  return request({
    url: `/pms/statistical/selectOrgFeeItemList`,
    method: "post",
    data
  });
}
export function selectAllFeeItemInfoList(data) {
  return request({
    url: `/pms/statistical/selectAllFeeItemInfoList`,
    method: "post",
    data
  });
}
export function selectByPatientId(data) {
  return request({
    url: `/pms/statistical/selectByPatientId`,
    method: "post",
    data
  });
}
export function setWorkDay(data) {
  return request({
    url: `/pms/booking/setWorkDay`,
    method: "post",
    data
  });
}
export function setRemindMessage(data) {
  return request({
    url: `/pms/booking/setRemindMessage`,
    method: "post",
    data
  });
}
export function selectRemindMessage(params) {
  return request({
    url: `/pms/booking/selectRemindMessage`,
    method: "get",
    params
  });
}

export function setSmallSpeakersQuestionMessage(data) {
  return request({
    url: `/pms/booking/setSmallSpeakersQuestionMessage`,
    method: "post",
    data
  });
}
export function selectSmallSpeakersQuestionMessage(params) {
  return request({
    url: `/pms/booking/selectSmallSpeakersQuestionMessage`,
    method: "get",
    params
  });
}

export function selectPeopleNum(params) {
  return request({
    url: `/pms/booking/selectPeopleNum`,
    method: "get",
    params
  });
}
export function setPeopleNum(data) {
  return request({
    url: `/pms/booking/setPeopleNum`,
    method: "post",
    data
  });
}
export function setRestDay(data) {
  return request({
    url: `/pms/booking/setRestDay`,
    method: "post",
    data
  });
}
export function selectWorkDay(params) {
  return request({
    url: `/pms/booking/selectWorkDay`,
    method: "get",
    params
  });
}
export function selectRestDay(params) {
  return request({
    url: `/pms/booking/selectRestDay`,
    method: "get",
    params
  });
}
export function synFeeItem(data) {
  return request({
    url: `/pms/booking/synFeeItem`,
    method: "post",
    data
  });
}
export function addFeeItem(data) {
  return request({
    url: `/pms/booking/addFeeItem`,
    method: "post",
    data
  });
}
export function selectNewFeeItemList(data) {
  return request({
    url: `/pms/booking/selectNewFeeItemList`,
    method: "post",
    data
  });
}
export function updateFeeItemCanState(data) {
  return request({
    url: `/pms/booking/updateFeeItemCanState`,
    method: "post",
    data
  });
}

export function saveBookingTimePlan(data) {
  return request({
    url: `/pms/bookingTime/saveBookingTimePlan`,
    method: "post",
    data
  });
}

export function getReservationByDate(params) {
  return request({
    url: "/pms/booking/getReservationListByDate",
    method: "get",
    params
  });
}

export function getBookingTimePlan(params) {
  return request({
    url: `/pms/bookingTime/getBookingTimePlan`,
    method: "get",
    params
  });
}

export function getReservationInfoById(params) {
  return request({
    url: `/pms/order/getReservationInfoById`,
    method: "get",
    params
  });
}

export function deleteBookingTimePlan(params) {
  return request({
    url: `/pms/bookingTime/deleteBookingTimePlan`,
    method: "get",
    params
  });
}
export function deleteBookingTimePlanOrg(params) {
  return request({
    url: `/pms/bookingTime/deleteBookingTimePlanOrg`,
    method: "get",
    params
  });
}

export function selectUploadedFeeItemList(data) {
  return request({
    url: `/pms/booking/selectUploadedFeeItemList`,
    method: "post",
    data
  });
}
export function searchReservationTaskList(params) {
  //任务管理
  return request({
    url: `/pms/booking/searchReservationTaskList`,
    method: "get",
    params
  });
}
export function uploadReservationTask(data) {
  //允许预约
  return request({
    url: `/pms/booking/uploadReservationTask`,
    method: "post",
    data
  });
}

export function updateReservationByUnbespoken(data) {
  // new zc 2021 0126 任务管理-禁止预约/允许预约
  return request({
    url: `/pms/booking/updateReservationByUnbespoken`,
    method: "post",
    data
  });
}
export function selectUploadFailPatientListt(params) {
  //任务管理
  return request({
    url: `/pms/booking/selectUploadFailPatientList`,
    method: "get",
    params
  });
}
export function reuploadFailPatient(data) {
  //允许预约
  return request({
    url: `/pms/booking/reuploadFailPatient`,
    method: "post",
    data
  });
}
export function selectUploadedBasExamSuiteList(data) {
  //允许预约
  return request({
    url: `/pms/booking/selectUploadedBasExamSuiteList`,
    method: "post",
    data
  });
}
export function updateBasExamSuiteUseState(data) {
  //允许预约
  return request({
    url: `/pms/booking/updateBasExamSuiteUseState`,
    method: "post",
    data
  });
}
export function selectNewBasExamSuiteList(data) {
  //允许预约
  return request({
    url: `/pms/booking/selectNewBasExamSuiteList`,
    method: "post",
    data
  });
}
export function addBasExamSuite(data) {
  //允许预约
  return request({
    url: `/pms/booking/addBasExamSuite `,
    method: "post",
    data
  });
}
export function synBasExamSuite(data) {
  //允许预约
  return request({
    url: `/pms/booking/synBasExamSuite `,
    method: "post",
    data
  });
}
export function updateBookingTimePlanOrgByFdisable(params) {
  return request({
    url: `/pms/bookingTime/updateBookingTimePlanOrgByFdisable`,
    method: "get",
    params
  });
}
export function getSuiteSort(data) {
  //查询所有的套餐分类
  return request({
    url: `/pms/booking/getSuiteSort`,
    method: "get",
    data
  });
}
export function deleteSuiteSort(data) {
  //查询所有的套餐分类
  return request({
    url: `/pms/booking/deleteSuiteSort`,
    method: "post",
    data
  });
}
export function addSuiteSort(data) {
  //查询所有的套餐分类
  return request({
    url: `/pms/booking/addSuiteSort`,
    method: "post",
    data
  });
}
export function updateSuiteSort(data) {
  //查询所有的套餐分类
  return request({
    url: `/pms/booking/updateSuiteSort`,
    method: "post",
    data
  });
}
export function getDoctorList(params) {
  // 查询按日期所排列的医生信息
  return request({
    url: `/pms/doctor/getDoctorList`,
    method: "get",
    params
  });
}
export function getDoctor(params) {
  // 根据医生名字获取医生信息
  return request({
    url: `/pms/doctor/getDoctor`,
    method: "get",
    params
  });
}
export function getAdvisoryList(params) {
  // 查询当前医生的工作量信息的体检人信息
  return request({
    url: `/pms/doctor/getAdvisoryList`,
    method: "get",
    params
  });
}
export function getQuestionNaireSynchronization(params) {
  // 同步
  return request({
    url: `/pms/question/getQuestionNaireSynchronization`,
    method: "get",
    params
  });
}
export function saveDoctors(data) {
  //设置日期中的值班医生
  return request({
    url: `/pms/doctor/saveDoctors`,
    method: "post",
    data
  });
}
export function updateDoctors(data) {
  //修改上下午医生
  return request({
    url: `/pms/doctor/updateDoctors`,
    method: "post",
    data
  });
}
export function deleteDoctors(data) {
  //删除医生排班信息
  return request({
    url: `/pms/doctor/deleteDoctors`,
    method: "post",
    data
  });
}
export function getGroupAppointmentBlacklist() {
  //查询团检预约黑名单
  return request({
    url: `/pms/booking/getGroupAppointmentBlacklist`,
    method: "get"
  });
}
export function saveGroupAppointmentBlacklist(params) {
  //查询团检预约黑名单
  return request({
    url: `/pms/booking/saveGroupAppointmentBlacklist`,
    method: "get",
    params
  });
}
export function saveTaskIsSpecialTask(params) {
  // 设置任务为特殊任物
  return request({
    url: `/pms/booking/saveTaskIsSpecialTask`,
    method: "get",
    params
  });
}
export function savePackageSpecialPackage(params) {
  // 设置套餐为特殊套餐
  return request({
    url: `/pms/booking/savePackageSpecialPackage`,
    method: "get",
    params
  });
}



// WEBPACK FOOTER //
// ./src/components/servers/api.js